import PageLabelBar from "../../components/common/PageLabelBar/PageLabelBar";

export default function Utenti() {
    return (
        <div className="content">
            <PageLabelBar title="Gestione Utenti" />
        </div>
    );
}